import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { PcTabsPage } from '../pc-tabs/pc-tabs';
import { AlertController } from 'ionic-angular';
import { PartesService} from '../../services/partes.services';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
//import { Cordova } from '@ionic-native/core';

@IonicPage()

@Component({
  selector: 'page-parte-detalle',
  templateUrl: 'parte-detalle.html',
})

export class ParteDetallePage {
  item = {id : null,disabled : false, Orden : null,Fecha : null, Poblacion : null, Unidades : 0, Observaciones : null, lineas : [{idParte: null, Vale:null,Variedad: null, Unidades: null}], personal : [{id: null, Nombre:null, Encargado : null, Plus : null}]};
  variedades = [];
  personal = [];
  vale = {idParte: null, Vale:null,Variedad: null, Unidades: null};
  persona = {id: null, Nombre:null, Encargado : null, Plus : null};

  pdfObj = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public partesService : PartesService,private plt: Platform, private file: File, private fileOpener: FileOpener){
    //Cargo las Variedades
    partesService.getVariedades()
      .subscribe(variedades => {
        this.variedades = variedades;
    });

    //Cargo el Personal
    this.personal = partesService.personal;
     
    //Si el item no es vacio, cargo el item que me pasan como parametro para edición.
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }else{ 
      this.item.id = partesService.getIdParte() + 1;
      this.item.lineas = [];
      this.item.personal = [];
    }
  }

  generateValesRows(){
    var lineasArray = [];
    var titulos = new Array( 'Nº VALE', 'VARIEDAD', 'UNIDADES');
    var linea = null;
    var total : number = 0;
    
    lineasArray.push(titulos);
    for(var i=0; i<this.item.lineas.length; i++){
      linea = new Array(this.item.lineas[i].Vale,this.item.lineas[i].Variedad,this.item.lineas[i].Unidades);
      lineasArray.push(linea);
      total = total + parseInt(this.item.lineas[i].Unidades);
    }
    linea = new Array( '', 'TOTAL',  total.toString());
    lineasArray.push(linea);
    return lineasArray;
  }

  generatePersonalRows(){
     var lineasArray = [];
     var titulos = new Array( 'Nº', 'APELLIDOS Y NOMBRE', 'TRANSPORTE');
     var linea = null;
     
     lineasArray.push(titulos);
     for(var i=0; i<this.item.personal.length; i++){
       linea = new Array(this.item.personal[i].id,this.item.personal[i].Nombre,this.item.personal[i].Plus);
       lineasArray.push(linea);
     }
     return lineasArray;
   }

  descargarPDF(){
    if(this.item.lineas.length <= 0){
      alert("Debes de asignar al menos un vale al Parte de Trabajo.");
    }else if(this.item.personal.length <= 0){
      alert("Debes de asignar al menos una persona al Parte de Trabajo.");
    }
    else{
      this.createPdf();
      this.downloadPdf();
    }
  }

  createPdf() {
    var docDefinition = {
      pageSize : 'A5',
      pageOrientation : 'portrait',//portrait - landscape
      //CABECERA
      header : {
        margin : [20,10,20,0],
        columns : [
                    {
                      text : 'SAT 125 CV ALMATERRA', style: 'header',
                      margin : [ 10, 0, 0, 0 ],
                      alignment : 'left',
                      fontSize : 10,
                      bold : true
                    } ,
                    {
                      text : this.item.id, style: 'subheader',
                      margin : [ 10, 0, 10, 0 ],
                      alignment : 'center',
                      fontSize : 10,
                      bold : true
                    } ,
                    {
                      text : this.item.Fecha, style: 'subheader',
                      margin : [ 10, 0, 0, 0 ],
                      alignment : 'right',  
                      fontSize : 10,
                      bold : true
                    }
                  ]
      },
      //CUERPO      
      content: [
          //TABLA VALES
          { text: 'Población: ' + this.item.Poblacion + ' Observaciones: ' + this.item.Observaciones, style: 'subheader' },
          { text: '', style: 'subheader' },
          {
            style: 'story',
            table: {
              headerRows: 1,
              body: this.generateValesRows(),
              
            },
            layout: {
             //style : 'header',
              //defaultBorder: false,
            }
          },
          { text: ' ', style: 'subheader' },
          //TABLA PERSONAL
          {
            style: 'story',
            table: {
              headerRows: 1,
              body: this.generatePersonalRows(),
              
            },
            layout: {
             //style : 'header',
              //defaultBorder: false,
            }
          },
      ],
      styles: {
        header: {
          fontSize: 14,
          bold: true,
        },
        subheader: {
          fontSize: 10,
          bold: true,
          margin: [0, 15, 0, 0]
        },
        story: {
          fontSize: 8,
          italic: true,
          alignment: 'center',
         // width: '50%',
        }
      }
    }
    this.pdfObj = pdfMake.createPdf(docDefinition);
  }

  downloadPdf() {
    //console.log(this.plt.platforms());
    //this.file.checkDir(this.file.dataDirectory, 'mydir').then(_ => console.log('Directory exists')).catch(err => console.log('Directory doesn\'t exist'));
    if (this.plt.is('cordova')) {
      this.pdfObj.getBuffer((buffer) => {
        var blob = new Blob([buffer], { type: 'application/pdf' });
        
        // Save the PDF to the data Directory of our App
        this.file.writeFile(this.file.dataDirectory, this.item.id + '.pdf', blob, { replace: true }).then(fileEntry => {
          // Open the PDf with the correct OS tools
          this.fileOpener.open(this.file.dataDirectory + this.item.id + '.pdf', 'application/pdf');
          
        })
      });
    } else {
      // On a browser simply use download!
      this.pdfObj.download( this.item.id + '.pdf');
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ParteDetallePage');
  }

  volver(){
    this.navCtrl.setRoot(PcTabsPage);
  }

  //Devuelve el numero de Unidades de las lineas de un Parte
  public countUnidades(){
    let Unidades = parseInt("0");
    for (let i = 0; i < this.item.lineas.length; i++){
      Unidades = Unidades + parseInt(this.item.lineas[i].Unidades);
    }
    return Unidades;
  }  

  //Añadir Parte
  addParte(){
    if(this.item.lineas.length <= 0){
      alert("Debes de asignar al menos un vale al Parte de Trabajo.");
    }else if(this.item.personal.length <= 0){
      alert("Debes de asignar al menos una persona al Parte de Trabajo.");
    }
    else{
      this.item.disabled = false;
      this.item.Unidades = this.countUnidades();
      this.item.Orden = 100000000 - this.item.id;
      this.partesService.editParte(this.item);
      this.navCtrl.pop();
    }
  } 

  //Borrar Vale
  deleteVale(linea){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Vale?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
            for (let j= 0; j < this.item.lineas.length; j++){
              if(this.item.lineas[j] == linea){
                this.item.lineas.splice(j, 1);
              }
            }
           }
        }
      ]
    });
    alert.present();
  }

  //Borrar PArte
  deleteParte(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Parte?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteParte(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  }  

  //Añadir un Vale a Parte Recolección
  addVale(){
    this.vale.idParte = this.item.id;
    this.vale.Unidades = "0";
    this.vale.Vale = "";
    this.vale.Variedad = "";
    this.item.lineas.push(this.vale);
    this.vale = {idParte: null,Vale:null,Variedad: null,Unidades: null};
  }

  //Añadir el Personal a Parte Recolección
  addPersonal(){
    for (let i= 0; i < this.personal.length; i++){
      if (this.personal[i].Activo == true){
        this.persona.id = this.personal[i].id;
        this.persona.Nombre = this.personal[i].Nombre;
        this.persona.Encargado = this.personal[i].Encargado;
        this.persona.Plus = ""; 
        this.item.personal.push(this.persona);
        this.persona = {id: null,Nombre:null, Encargado : null, Plus : null};
      }
    }
  }

  //Borrar el personal asignado al parte
  deletePersonal(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar al personal de este Parte?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.item.personal = [];
           }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/parte-detalle/parte-detalle.ts